<div class="d-flex justify-content-center align-items-center" style="height: 300px;">
    <ng-lottie [options]="options" [styles]="{ width: '300px', height: '300px' }"></ng-lottie>
  </div>